exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App__App--1BnYY {\n  width: 100%;\n  height: 100%;\n  position: relative; }\n  .App__App--1BnYY .drawing-board {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n", ""]);

// exports
exports.locals = {
	"App": "App__App--1BnYY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./~/sass-loader/lib/loader.js!./~/postcss-loader/lib?{"ident":"postcss"}!./src/board/App.scss
// module id = 570
// module chunks = 0